import { render, staticRenderFns } from "./RichEditor.vue?vue&type=template&id=50866dde"
import script from "./RichEditor.vue?vue&type=script&lang=ts"
export * from "./RichEditor.vue?vue&type=script&lang=ts"
import style0 from "./RichEditor.vue?vue&type=style&index=0&id=50866dde&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports